import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cfe79014"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "commentsContainer" }
const _hoisted_2 = { class: "addCommentContainer" }
const _hoisted_3 = { class: "btn btn-link" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-paperclip fa-2x" }, null, -1))
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "addCommentAttachment"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-times" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "scrollListContainer" }
const _hoisted_11 = {
  key: 0,
  class: "scrollListItem"
}
const _hoisted_12 = { class: "top" }
const _hoisted_13 = {
  key: 0,
  class: "date"
}
const _hoisted_14 = {
  key: 1,
  class: "author"
}
const _hoisted_15 = {
  key: 2,
  class: "author"
}
const _hoisted_16 = {
  key: 3,
  class: "commentDate"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-mini btn-danger"
}, "x", -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "bottom" }
const _hoisted_21 = ["href"]
const _hoisted_22 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_auto_textarea = _resolveComponent("auto-textarea")!
  const _component_file_input = _resolveComponent("file-input")!
  const _component_comment_text = _resolveComponent("comment-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.modify)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: "commentAttachmentDropArea droparea",
              onDrop: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args)))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Rilascia qui per allegare",
                text: "Rilascia qui per allegare"
              })
            ], 32),
            _createVNode(_component_auto_textarea, {
              class: "form-control",
              placeholder: "Scrivi qui",
              modelValue: _ctx.commentText,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.commentText) = $event)),
              maxHeight: 150
            }, null, 8, ["modelValue"]),
            _createElementVNode("label", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_file_input, {
                class: "hidden",
                modelValue: _ctx.tempFile,
                "onUpdate:modelValue": [
                  _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tempFile) = $event)),
                  _ctx.addFile
                ]
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-success",
              disabled: !_ctx.canSaveComment,
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addComment && _ctx.addComment(...args)))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Salva",
                text: "Salva"
              })
            ], 8, _hoisted_5)
          ]),
          (_ctx.filesToUpload.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filesToUpload, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.name
                  }, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Allegato:",
                      text: "Allegato:"
                    }),
                    _createTextVNode(" " + _toDisplayString(item.name) + " ", 1),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-danger btn-sm",
                      onClick: ($event: any) => (_ctx.removeFile(item))
                    }, _hoisted_9, 8, _hoisted_7)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_10, [
      (_ctx.comments.length == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_component_localized_text, {
              localizedKey: "Nessun elemento inserito",
              text: "Nessun elemento inserito"
            })
          ]))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.comments, (item, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "scrollListItem comment",
              key: i
            }, [
              _createElementVNode("div", _hoisted_12, [
                (!item.startDate)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.$filters.date(item.createdOn, 'DD-MM-YYYY HH:mm')), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(item.author.name), 1)),
                (!item.startDate)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(item.author.name), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("b", null, "--> " + _toDisplayString(_ctx.$filters.date(item.startDate, 'DD-MM-YYYY HH:mm')), 1)
                    ])),
                (_ctx.$store.state.isAdmin())
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 4,
                      class: "deleteComment",
                      onClick: ($event: any) => (_ctx.deleteComment(item))
                    }, _hoisted_19, 8, _hoisted_17))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_comment_text, { comment: item }, null, 8, ["comment"]),
                (item.attachments.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.attachments, (x, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: i,
                        class: "fs-12"
                      }, [
                        _createElementVNode("a", {
                          class: "text-orange",
                          href: x.publicUrl,
                          target: "_blank"
                        }, _toDisplayString(x.fileName), 9, _hoisted_21)
                      ]))
                    }), 128))
                  : _createCommentVNode("", true),
                (item.attachmentUrl.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(item.attachmentUrl, (url, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: i,
                        class: "fs-12"
                      }, [
                        _createElementVNode("a", {
                          class: "text-orange",
                          href: url,
                          target: "_blank"
                        }, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Allegato",
                            text: "Allegato"
                          }),
                          _createTextVNode(" " + _toDisplayString(i + 1), 1)
                        ], 8, _hoisted_22)
                      ]))
                    }), 128))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
    ])
  ]))
}